import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../../../Components/CSS/FilterStyle.css";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";

class TeacherForm extends Component {
  constructor(props) {
    super(props);
    this.state = { staffList: [] };
  }

  componentDidMount() {
    this.getTeacher();
  }

  getTeacher = async () => {
    try {
      const response = await Axios.get(`${url}/api/staffs`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.staffs.length !== 0) {
        this.setState({
          staffList: response.data.staffs,
        });
      } else {
        this.setState({
          staffList: [],
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getTeacher();
      }
    }
  };

  render() {
    const { classes, data, handleChange } = this.props;
    const filteredTeacher = this.state.staffList.filter(
      (data) => data.department === "Teaching"
    );
    return (
      <div className={classes.root}>
        <div className={classes.fieldStyle}>
          <TextField
            name="teacherName"
            select
            label="Teacher's Name"
            variant="outlined"
            margin="normal"
            placeholder="Search by teacher's name"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.teacherName}
            onChange={handleChange}
          >
            <option value="">Select Any Teacher</option>
            {filteredTeacher.map((data, index) => (
              <option key={index} value={data._id}>
                {data.fullName}
              </option>
            ))}
          </TextField>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(TeacherForm));
